var _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpiredProjectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-expired-1241405",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.998,
    height: 19,
    viewBox: "0 0 18.998 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9633",
    "data-name": "Path 9633",
    d: "M30.05,23.5H26.5v.818h4.368V18.19H30.05Z",
    transform: "translate(-21.793 -15.179)",
    fill: "#ecba5f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9634",
    "data-name": "Path 9634",
    d: "M20.43,13.708a8.564,8.564,0,1,0-6.712,6.71,4.815,4.815,0,1,0,6.712-6.71Zm-8.38,6.06a7.734,7.734,0,1,1,7.728-7.734,7.826,7.826,0,0,1-.1,1.238,4.815,4.815,0,0,0-6.4,6.4,7.8,7.8,0,0,1-1.237.1Zm5.6,1.872a4,4,0,1,1,4-4,4,4,0,0,1-4,4Z",
    transform: "translate(-3.47 -3.457)",
    fill: "#ecba5f"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3871",
    "data-name": "Rectangle 3871",
    width: 0.818,
    height: 3.832,
    transform: "translate(13.772 11.551)",
    fill: "#ecba5f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3872",
    "data-name": "Rectangle 3872",
    width: 0.818,
    height: 0.971,
    transform: "translate(13.772 16.047)",
    fill: "#ecba5f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredProjectIcon);
export default __webpack_public_path__ + "static/media/expired-project-icon.d9b17b252101013373895a9848d21e42.svg";
export { ForwardRef as ReactComponent };